module.exports = __webpack_public_path__ + "images/DoYou-6eaaf1.png";